export const hexToRgba = (hex: string, alpha: number) => {
  const hexColor = /#([a-f0-9]{6}|[a-f0-9]{3})\b/gi;

  if (!hex.match(hexColor)) {
    return hex;
  }

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha < 0 || alpha > 1) {
    return `rgba(${r}, ${g}, ${b}, ${1})`;
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
